import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "bulkBar", "count"]

  toggle(event) {
    const button = event.currentTarget
    const url = button.dataset.url
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    }).then(response => {
      if (!response.ok) return
      return response.text()
    }).then(html => {
      if (html) Turbo.renderStreamMessage(html)
    })
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => { cb.checked = checked })
    this.updateBulkBar()
  }

  updateBulkBar() {
    const selected = this.checkboxTargets.filter(cb => cb.checked)
    const count = selected.length
    const total = this.checkboxTargets.length

    if (this.hasCountTarget) this.countTarget.textContent = count
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = count === total && total > 0
      this.selectAllTarget.indeterminate = count > 0 && count < total
    }
    if (this.hasBulkBarTarget) {
      this.bulkBarTarget.classList.toggle("hidden", count === 0)
    }
  }

  bulkRemove() {
    const ids = this.selectedIds()
    if (ids.length === 0 && !this._allPagesSelected) return
    const count = this._allPagesSelected ? "tous les membres correspondants au filtre" : `${ids.length} contact(s)`
    if (!confirm(`Retirer ${count} de cette liste ?`)) return
    let params = { remove: "true" }
    if (this._allPagesSelected) {
      // Transmet le filtre/recherche courant pour que le backend retire EXACTEMENT
      // les membres affichés (et pas toute la liste). Voir filtered_memberships côté Rails.
      params.all_pages = "true"
      if (this.element.dataset.q) params.q = this.element.dataset.q
      if (this.element.dataset.filter) params.filter = this.element.dataset.filter
    }
    this.submitBulk(ids, params)
  }

  // Story 2.G-final (21/05/2026) — Sélectionne tous les memberships de la liste
  // au-delà de la page courante. Le bulk submit passera all_pages=true au backend.
  selectAllPages() {
    this._allPagesSelected = true
    this.checkboxTargets.forEach(cb => { cb.checked = true })
    if (this.hasCountTarget) {
      this.countTarget.textContent = "tous"
    }
    if (this.hasBulkBarTarget) this.bulkBarTarget.classList.remove("hidden")
  }

  bulkExclude() {
    this.submitBulk(this.selectedIds(), { exclude: "true" })
  }

  bulkInclude() {
    this.submitBulk(this.selectedIds(), { exclude: "false" })
  }

  selectedIds() {
    return this.checkboxTargets.filter(cb => cb.checked).map(cb => cb.value)
  }

  submitBulk(ids, extraParams) {
    if (ids.length === 0) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.element.dataset.bulkPath

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "patch"
    form.appendChild(methodInput)

    ids.forEach(id => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "membership_ids[]"
      input.value = id
      form.appendChild(input)
    })

    Object.entries(extraParams).forEach(([key, val]) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = key
      input.value = val
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
